import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { useWorkflowStore } from '@/stores/workflowStore';
import { toast } from 'sonner';

interface WorkflowCloneDialogProps {
  workflowId: string | null;
  workflowName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function WorkflowCloneDialog({
  workflowId,
  workflowName,
  open,
  onOpenChange,
}: WorkflowCloneDialogProps) {
  const [newName, setNewName] = useState(`${workflowName} (Copy)`);
  const { cloneWorkflow, saveWorkflow } = useWorkflowStore();

  const handleClone = () => {
    if (!workflowId) {
      toast.error('Workflow not found');
      return;
    }

    if (!newName.trim()) {
      toast.error('Please enter a name for the cloned workflow');
      return;
    }

    cloneWorkflow(workflowId, newName);
    saveWorkflow();
    toast.success(`Workflow cloned as "${newName}"`);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Clone Workflow</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="workflow-name">Original Workflow</Label>
            <Input disabled value={workflowName} />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="new-name">New Workflow Name</Label>
            <Input
              id="new-name"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="Enter new workflow name"
              autoFocus
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleClone}>Clone</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
